import { OperatorFunction, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";


export function NgxMultiExcludes(excludes: Observable<String[]>): OperatorFunction<Multi[], Multi[]> {

  return switchMap(results => {
    return excludes.pipe(
      map(_excludes => {
        
        const newResults = results.map(r => Object.assign({}, r, { series: r.series.map(s => _excludes.indexOf(r.name) == -1 ? s : Object.assign({}, s, { value: 0 })) }));

        return newResults
      }));

  });


  
}
